import React, { useEffect, useState, useCallback, useRef } from "react";
import login_bg from "../assets/images/login_bg.webp";
import { Link, useLocation, useNavigate } from "react-router-dom";
import useAuthStore from "../store/useAuthStore";
import logo from "../assets/images/logo.webp";
import useSignIn from "react-auth-kit/hooks/useSignIn";

/* ══════════════════════════════════════════════════
   INJECT STYLES
══════════════════════════════════════════════════ */
const injectKF = () => {
  if (document.getElementById("lg-kf")) return;
  const s = document.createElement("style");
  s.id = "lg-kf";
  s.innerHTML = `
    @keyframes slideInBot {
      from { opacity:0; transform:translateY(-14px) scale(0.93); }
      to   { opacity:1; transform:translateY(0)     scale(1); }
    }
    @keyframes botCursor  { 0%,100%{opacity:1} 50%{opacity:0} }
    @keyframes speakBar   { 0%,100%{transform:scaleY(1)} 50%{transform:scaleY(1.8)} }
    @keyframes pulseDot   { 0%,100%{opacity:1} 50%{opacity:0.4} }
    @keyframes botBobSvg  { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-2.5px)} }
    @keyframes floatHeartL1 {
      0%  { transform:translate(0,0)         scale(1);    opacity:1; }
      100%{ transform:translate(-14px,-54px) scale(0.18); opacity:0; }
    }
    @keyframes floatHeartL2 {
      0%  { transform:translate(0,0)        scale(0.82); opacity:0.9; }
      100%{ transform:translate(-4px,-58px) scale(0.12); opacity:0; }
    }
    @keyframes floatHeartL3 {
      0%  { transform:translate(0,0)       scale(0.68); opacity:0.8; }
      100%{ transform:translate(9px,-50px) scale(0.22); opacity:0; }
    }
    @keyframes floatHeartR1 {
      0%  { transform:translate(0,0)        scale(1);    opacity:1; }
      100%{ transform:translate(14px,-54px) scale(0.18); opacity:0; }
    }
    @keyframes floatHeartR2 {
      0%  { transform:translate(0,0)       scale(0.82); opacity:0.9; }
      100%{ transform:translate(4px,-58px) scale(0.12); opacity:0; }
    }
    @keyframes floatHeartR3 {
      0%  { transform:translate(0,0)        scale(0.68); opacity:0.8; }
      100%{ transform:translate(-9px,-50px) scale(0.22); opacity:0; }
    }

    .lg-bot-bob-g { animation: botBobSvg 3s ease-in-out infinite; }
    .lg-hl1 { animation: floatHeartL1 2s 0.0s  ease-out infinite; transform-origin: 23px 27px; }
    .lg-hl2 { animation: floatHeartL2 2s 0.65s ease-out infinite; transform-origin: 23px 27px; }
    .lg-hl3 { animation: floatHeartL3 2s 1.3s  ease-out infinite; transform-origin: 23px 27px; }
    .lg-hr1 { animation: floatHeartR1 2s 0.2s  ease-out infinite; transform-origin: 49px 27px; }
    .lg-hr2 { animation: floatHeartR2 2s 0.85s ease-out infinite; transform-origin: 49px 27px; }
    .lg-hr3 { animation: floatHeartR3 2s 1.5s  ease-out infinite; transform-origin: 49px 27px; }

    .lg-bot-wrap {
      position: fixed;
      z-index: 99999;
      animation: slideInBot 0.32s cubic-bezier(0.34,1.3,0.64,1);
    }
    .lg-bot-wrap::before {
      content: '';
      position: absolute;
      width: 16px; height: 9px;
      background: #ce202e;
      clip-path: polygon(50% 0%,100% 100%,0% 100%);
    }
    .lg-bot-wrap.below::before  { top:-9px;    left:28px; }
    .lg-bot-wrap.above::before  { bottom:-9px; left:28px; transform:rotate(180deg); }
    .lg-bot-wrap.toright::before {
      top: calc(50% - 8px); left: -9px;
      width: 9px; height: 16px;
      clip-path: polygon(0% 50%,100% 0%,100% 100%);
    }
    .lg-bot-wrap.toleft::before {
      top: calc(50% - 8px); right: -9px;
      width: 9px; height: 16px;
      clip-path: polygon(100% 50%,0% 0%,0% 100%);
    }
    .lg-bot-wrap.pinned::before { display: none; }

    .lg-bot-popup {
      background: #fff;
      border-radius: 18px;
      border: 1px solid rgba(0,0,0,0.07);
      overflow: hidden;
      box-shadow: 0 4px 6px rgba(0,0,0,0.04), 0 12px 40px rgba(0,0,0,0.13), 0 2px 10px rgba(206,32,46,0.08);
    }
    .lg-bp-top {
      background: linear-gradient(135deg,#ce202e 0%,#8b0000 60%,#5c0000 100%);
      padding: clamp(9px,2.6vw,15px) clamp(10px,3vw,16px) clamp(8px,2.4vw,13px);
      display: flex; align-items: center; gap: clamp(7px,2vw,13px);
      position: relative; overflow: visible;
    }
    .lg-bp-top::after {
      content:''; position:absolute; inset:0; pointer-events:none;
      background-image: linear-gradient(rgba(255,255,255,.04) 1px,transparent 1px), linear-gradient(90deg,rgba(255,255,255,.04) 1px,transparent 1px);
      background-size: 18px 18px;
    }
    .lg-bp-avatar { position:relative; flex-shrink:0; z-index:1; overflow:visible; }
    .lg-bp-avatar svg { width: clamp(46px,12vw,64px); height: clamp(46px,12vw,64px); display: block; }
    .lg-speak-bars {
      display:flex; align-items:flex-end; gap:2.5px;
      position:absolute; bottom:-3px; right:-6px;
      background:rgba(0,0,0,.3); border-radius:5px; padding:3px 4px 2px; z-index:2;
    }
    .lg-sbar { width:3px; border-radius:2px; background:#fff; transform-origin:bottom; }
    .lg-sbar:nth-child(1){ height:5px;  animation:speakBar .5s .00s ease-in-out infinite; }
    .lg-sbar:nth-child(2){ height:10px; animation:speakBar .5s .10s ease-in-out infinite; }
    .lg-sbar:nth-child(3){ height:7px;  animation:speakBar .5s .20s ease-in-out infinite; }
    .lg-sbar:nth-child(4){ height:4px;  animation:speakBar .5s .30s ease-in-out infinite; }
    .lg-bp-meta { flex:1; z-index:1; min-width:0; overflow:hidden; }
    .lg-bp-name { font-size:clamp(10px,2.8vw,13.5px); font-weight:800; color:#fff; letter-spacing:.06em; font-family:'DM Mono','Fira Code',monospace; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
    .lg-bp-sub  { font-size:clamp(8.5px,2.4vw,11px); color:rgba(255,255,255,.72); display:flex; align-items:center; gap:5px; margin-top:3px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
    .lg-bp-sdot { width:6px; height:6px; border-radius:50%; background:#6effa0; box-shadow:0 0 6px rgba(100,255,150,.9); flex-shrink:0; animation:pulseDot 2s ease-in-out infinite; }
    .lg-bp-badge { z-index:1; flex-shrink:0; background:rgba(255,255,255,.15); border:1px solid rgba(255,255,255,.3); border-radius:20px; padding:3px clamp(7px,2vw,10px); font-size:clamp(9px,2.4vw,11px); font-weight:700; color:#fff; white-space:nowrap; letter-spacing:.02em; }
    .lg-bp-tag  { background:linear-gradient(90deg,#fff5f5,#fff); border-bottom:1px solid rgba(206,32,46,.1); padding:7px clamp(10px,3vw,16px); display:flex; align-items:center; gap:8px; }
    .lg-bp-tag-dot { width:6px; height:6px; border-radius:50%; background:#ce202e; flex-shrink:0; }
    .lg-bp-tag-txt { font-size:clamp(8.5px,2.4vw,10.5px); font-weight:800; color:#ce202e; letter-spacing:.09em; }
    .lg-bp-body { padding:clamp(10px,3vw,16px) clamp(10px,3vw,18px) clamp(8px,2.4vw,14px); }
    .lg-bp-msg  { font-size:clamp(12px,3.4vw,14px); line-height:1.6; color:#1a1a1a; min-height:auto; word-break:break-word; margin:0; }
    .lg-bp-msg strong { color:#ce202e; font-weight:800; }
    .lg-bp-msg em     { color:#8b0000; font-style:normal; font-weight:700; }
    .lg-bp-cursor { display:inline-block; width:2.5px; height:14px; background:#ce202e; border-radius:2px; margin-left:2px; vertical-align:middle; animation:botCursor .65s ease-in-out infinite; }
    .lg-bp-foot { padding:10px clamp(10px,3vw,16px) clamp(10px,3vw,14px); display:flex; align-items:center; justify-content:space-between; gap:8px; border-top:1px solid rgba(0,0,0,.05); background:#fafafa; flex-wrap:wrap; }
    .lg-bp-dots { display:flex; gap:5px; align-items:center; }
    .lg-bpd     { width:7px; height:7px; border-radius:50%; background:#e0e0e0; transition:all .3s; flex-shrink:0; }
    .lg-bpd.on  { width:20px; border-radius:999px; background:linear-gradient(90deg,#ce202e,#8b0000); }
    .lg-bp-skip { background:none; border:none; cursor:pointer; font-size:clamp(10px,2.8vw,11.5px); color:#bbb; padding:5px 7px; border-radius:7px; transition:all .18s; white-space:nowrap; }
    .lg-bp-skip:hover { background:#f0f0f0; color:#888; }
    .lg-bp-next { background:linear-gradient(135deg,#ce202e,#8b0000); color:#fff; border:none; border-radius:10px; padding:7px clamp(12px,3.6vw,18px); font-size:clamp(11px,3vw,13px); font-weight:800; cursor:pointer; letter-spacing:.03em; box-shadow:0 4px 16px rgba(206,32,46,.4); transition:all .18s; white-space:nowrap; }
    .lg-bp-next:hover  { transform:translateY(-1px); box-shadow:0 6px 22px rgba(206,32,46,.5); }
    .lg-bp-next:active { transform:scale(0.97); }
  `;
  document.head.appendChild(s);
};

/* ══════════════════════════════════════════════════
   BOT FACE SVG
══════════════════════════════════════════════════ */
const BotFaceSVG: React.FC = () => (
  <svg viewBox="0 0 72 72" fill="none" style={{ overflow: "visible" }}>
    <defs>
      <style>{`
        .lg-bot-bob-g { animation: botBobSvg 3s ease-in-out infinite; }
        .lg-hl1 { animation: floatHeartL1 2s 0.0s  ease-out infinite; transform-origin: 23px 27px; }
        .lg-hl2 { animation: floatHeartL2 2s 0.65s ease-out infinite; transform-origin: 23px 27px; }
        .lg-hl3 { animation: floatHeartL3 2s 1.3s  ease-out infinite; transform-origin: 23px 27px; }
        .lg-hr1 { animation: floatHeartR1 2s 0.2s  ease-out infinite; transform-origin: 49px 27px; }
        .lg-hr2 { animation: floatHeartR2 2s 0.85s ease-out infinite; transform-origin: 49px 27px; }
        .lg-hr3 { animation: floatHeartR3 2s 1.5s  ease-out infinite; transform-origin: 49px 27px; }
      `}</style>
    </defs>
    <g className="lg-bot-bob-g">
      <line x1="36" y1="10" x2="36" y2="3" stroke="rgba(255,255,255,0.82)" strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="36" cy="2" r="3.2" fill="rgba(255,255,255,0.9)" />
      <rect x="7" y="10" width="58" height="46" rx="15" fill="rgba(255,255,255,0.97)" />
      <circle cx="7"  cy="32" r="5.5" fill="rgba(255,255,255,0.85)" stroke="rgba(206,32,46,0.45)" strokeWidth="1.2" />
      <circle cx="65" cy="32" r="5.5" fill="rgba(255,255,255,0.85)" stroke="rgba(206,32,46,0.45)" strokeWidth="1.2" />
      <rect x="11" y="17" width="24" height="20" rx="9" fill="#ce202e" />
      <rect x="37" y="17" width="24" height="20" rx="9" fill="#8b0000" />
      <ellipse cx="23" cy="27" rx="9" ry="8" fill="white" />
      <ellipse cx="49" cy="27" rx="9" ry="8" fill="white" />
      <g className="lg-hl1"><path d="M23,33 C23,33 12,23 12,17 C12,13 17,11 23,17 C29,11 34,13 34,17 C34,23 23,33 23,33Z" fill="#ff3d6b" /></g>
      <g className="lg-hl2"><path d="M23,33 C23,33 12,23 12,17 C12,13 17,11 23,17 C29,11 34,13 34,17 C34,23 23,33 23,33Z" fill="#ce202e" opacity="0.88" /></g>
      <g className="lg-hl3"><path d="M23,33 C23,33 12,23 12,17 C12,13 17,11 23,17 C29,11 34,13 34,17 C34,23 23,33 23,33Z" fill="#ff7099" /></g>
      <g className="lg-hr1"><path d="M49,33 C49,33 38,23 38,17 C38,13 43,11 49,17 C55,11 60,13 60,17 C60,23 49,33 49,33Z" fill="#ff3d6b" /></g>
      <g className="lg-hr2"><path d="M49,33 C49,33 38,23 38,17 C38,13 43,11 49,17 C55,11 60,13 60,17 C60,23 49,33 49,33Z" fill="#ce202e" opacity="0.88" /></g>
      <g className="lg-hr3"><path d="M49,33 C49,33 38,23 38,17 C38,13 43,11 49,17 C55,11 60,13 60,17 C60,23 49,33 49,33Z" fill="#ff7099" /></g>
      <path d="M16,46 Q36,60 56,46" stroke="#ce202e" strokeWidth="2.8" strokeLinecap="round" fill="none" />
      <ellipse cx="12" cy="44" rx="6" ry="4" fill="rgba(255,100,100,0.2)" />
      <ellipse cx="60" cy="44" rx="6" ry="4" fill="rgba(255,100,100,0.2)" />
      <line x1="7"  y1="28" x2="2"  y2="23" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round" />
      <line x1="7"  y1="36" x2="2"  y2="39" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round" />
      <line x1="65" y1="28" x2="70" y2="23" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round" />
      <line x1="65" y1="36" x2="70" y2="39" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round" />
    </g>
  </svg>
);

/* ══════════════════════════════════════════════════
   TYPES + STEP DATA
══════════════════════════════════════════════════ */
type BotSide = "below" | "above" | "toright" | "toleft";

interface StepData {
  tag:    string;
  plain:  string;
  html:   string;
  sideLg: BotSide;
  sideSm: BotSide;
}

const STEPS: StepData[] = [
  {
    tag:   "STEP 1 OF 4 — GET STARTED",
    plain: "First time here? Create a free account — it only takes 30 seconds!",
    html:  "First time here? <strong>Create a free account</strong> — it only takes 30 seconds!",
    sideLg: "below", sideSm: "below",
  },
  {
    tag:   "STEP 2 OF 4 — YOUR EMAIL",
    plain: "Enter the email address you used when signing up. We'll never share it.",
    html:  "Enter the <strong>email address</strong> you used when signing up. We'll never share it.",
    sideLg: "below", sideSm: "below",
  },
  {
    tag:   "STEP 3 OF 4 — YOUR PASSWORD",
    plain: "Type your password here. Use the eye icon to show or hide it.",
    html:  "Type your <strong>password</strong> here. Use the <strong>eye icon</strong> to show or hide it.",
    sideLg: "below", sideSm: "below",
  },
  {
    tag:   "STEP 4 OF 4 — ALL SET!",
    plain: "All done! Hit Sign In to explore your dashboard and find your matches!",
    html:  "All done! Hit <strong>Sign In</strong> to explore your dashboard and find your matches!",
    sideLg: "below", sideSm: "below",
  },
];

const TOTAL = STEPS.length;

/* ══════════════════════════════════════════════════
   BOT POPUP COMPONENT
══════════════════════════════════════════════════ */
interface BotPopupProps {
  anchorRef: React.RefObject<HTMLDivElement | null>;
  step:      number;
  data:      StepData;
  onSkip:    () => void;
  onNext:    () => void;
  nextLabel: string;
}

const BotPopup: React.FC<BotPopupProps> = ({ anchorRef, step, data, onSkip, onNext, nextLabel }) => {
  const [pos,        setPos]        = useState<{ top: number; left: number } | null>(null);
  const [popupW,     setPopupW]     = useState(320);
  const [activeSide, setActiveSide] = useState<BotSide>("below");
  const [pinnedMobile, setPinnedMobile] = useState(false);
  const [displayed,  setDisplayed]  = useState("");
  const [done,       setDone]       = useState(false);
  const [statusText, setStatusText] = useState("typing...");
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  /* FIX: the position math previously assumed a hardcoded popup height
     (285px). The real card is often shorter (depends on how much the
     step's message wraps), so "above" placements left a gap between the
     popup's true bottom edge and the anchor — and whatever field sat in
     that gap (e.g. the password input, sitting just above the Sign In
     button) became visible there, making the popup look like it was
     pointing at the wrong field. Measuring the actual rendered height
     and using that for the math keeps the popup flush against whichever
     field it's actually meant to be anchored to. */
  const cardRef  = useRef<HTMLDivElement>(null);
  const [measuredH, setMeasuredH] = useState<number | null>(null);

  useEffect(() => {
    if (!cardRef.current) return;
    const ro = new ResizeObserver(entries => {
      for (const entry of entries) setMeasuredH(entry.contentRect.height);
    });
    ro.observe(cardRef.current);
    return () => ro.disconnect();
  }, []);

  const getDims = (side: BotSide): { pw: number; ph: number } => {
    const vw = window.innerWidth;
    if (side === "toright" || side === "toleft") return { pw: 260, ph: 290 };
    if (vw < 400) return { pw: 240, ph: 285 };
    if (vw < 576) return { pw: 268, ph: 285 };
    if (vw < 992) return { pw: 300, ph: 285 };
    return { pw: 320, ph: 285 };
  };

  useEffect(() => {
    const calc = () => {
      if (!anchorRef.current) return;
      const r = anchorRef.current.getBoundingClientRect();
      const vw = window.innerWidth, vh = window.innerHeight;
      const isMobile = vw < 992, gap = 12;

      /* FIX: On mobile, the popup must stay attached to the field it is
         describing. The previous logic checked whether placing the
         popup below the field would visually overlap ANY other input
         on the page — but on a short login form the fields sit close
         together, so that check almost always failed and the popup
         fell back to being pinned at the very bottom of the viewport,
         disconnected from the field (e.g. the "email" step's popup
         landing on top of the Sign In button instead of under the
         email input).

         New approach — simple and robust for a short form:
           1) Try directly BELOW the field — use it if it fits on screen.
           2) Otherwise try directly ABOVE the field — use it if it fits.
           3) Only as a last resort, pin it near the bottom of the
              viewport (e.g. very short screens where neither fits). */
      if (isMobile) {
        const pw = Math.min(vw - 32, 380);
        const ph = measuredH ?? 285;
        const belowTop = r.bottom + gap;
        const aboveTop = r.top - ph - gap;

        let top: number;
        let side: BotSide;
        let pinned = false;

        if (belowTop + ph <= vh - 8) {
          top = belowTop;
          side = "below";
        } else if (aboveTop >= 8) {
          top = aboveTop;
          side = "above";
        } else {
          top = Math.max(8, vh - ph - 16);
          side = "below";
          pinned = true;
        }

        setPinnedMobile(pinned);
        setActiveSide(side);
        setPopupW(pw);
        setPos({ top, left: Math.max(8, (vw - pw) / 2) });
        return;
      }
      setPinnedMobile(false);

      let side: BotSide = data.sideLg;
      let { pw, ph } = getDims(side);
      if (measuredH) ph = measuredH;
      let top = 0, left = 0;

      if (side === "below") {
        top = r.bottom + gap; left = r.left;
        if (left + pw > vw - 8) left = vw - pw - 8;
        if (top + ph > vh - 8) { top = r.top - ph - gap; side = "above"; if (top < 8) { top = r.bottom + gap; side = "below"; } }
      } else if (side === "above") {
        top = r.top - ph - gap; left = r.left;
        if (left + pw > vw - 8) left = vw - pw - 8;
        if (top < 8) { top = r.bottom + gap; side = "below"; }
      } else if (side === "toright") {
        top = r.top + r.height / 2 - ph / 2; left = r.right + gap;
        if (left + pw > vw - 8) { left = r.left - pw - gap; side = "toleft"; ({ pw, ph } = getDims(side)); if (left < 8) { left = r.left; top = r.bottom + gap; side = "below"; ({ pw, ph } = getDims(side)); } }
      } else {
        top = r.top + r.height / 2 - ph / 2; left = r.left - pw - gap;
        if (left < 8) { left = r.right + gap; side = "toright"; ({ pw, ph } = getDims(side)); if (left + pw > vw - 8) { left = r.left; top = r.bottom + gap; side = "below"; ({ pw, ph } = getDims(side)); } }
      }

      left = Math.max(8, Math.min(left, vw - pw - 8));
      top  = Math.max(8, Math.min(top,  vh - ph - 8));
      setActiveSide(side); setPopupW(pw); setPos({ top, left });
    };
    calc();
    window.addEventListener("resize", calc);
    window.addEventListener("scroll", calc, true);
    return () => { window.removeEventListener("resize", calc); window.removeEventListener("scroll", calc, true); };
  }, [anchorRef, data.sideLg, data.sideSm, step, measuredH]);

  useEffect(() => {
    setDisplayed(""); setDone(false); setStatusText("typing..."); setMeasuredH(null);
    let i = 0;
    const tick = () => {
      if (i <= data.plain.length) { setDisplayed(data.plain.slice(0, i)); i++; timerRef.current = setTimeout(tick, 24); }
      else { setDone(true); setStatusText("Online — here to guide you!"); }
    };
    tick();
    return () => { if (timerRef.current) clearTimeout(timerRef.current); };
  }, [data.plain, step]);

  /* FIX: previously this returned null until `pos` existed — but `pos`
     depends on the real measured height, and the real measured height
     can only come from ResizeObserver watching the card AFTER it has
     mounted. That was a deadlock: the card never mounted early enough
     to be measured, so the observer never fired, and every position
     calculation silently fell back to the hardcoded 285px guess (the
     original bug this was supposed to fix). Instead, always mount the
     card — just keep it invisible/non-interactive until we have both a
     position AND a real measurement to compute it from — so it can be
     measured, then revealed already correctly placed. */
  const ready = pos !== null && measuredH !== null;

  return (
    <div
      className={`lg-bot-wrap ${activeSide}${pinnedMobile ? " pinned" : ""}`}
      style={{
        top: pos?.top ?? -9999,
        left: pos?.left ?? -9999,
        visibility: ready ? "visible" : "hidden",
        pointerEvents: ready ? "auto" : "none",
      }}
    >
      <div ref={cardRef} className="lg-bot-popup" style={{ width: `${popupW}px` }}>
        <div className="lg-bp-top">
          <div className="lg-bp-avatar">
            <BotFaceSVG />
            <div className="lg-speak-bars">
              <div className="lg-sbar" /><div className="lg-sbar" />
              <div className="lg-sbar" /><div className="lg-sbar" />
            </div>
          </div>
          <div className="lg-bp-meta">
            <div className="lg-bp-name">SLAMMMM GUIDE</div>
            <div className="lg-bp-sub"><div className="lg-bp-sdot" /><span>{statusText}</span></div>
          </div>
          <div className="lg-bp-badge">{step} / {TOTAL}</div>
        </div>
        <div className="lg-bp-tag">
          <div className="lg-bp-tag-dot" />
          <div className="lg-bp-tag-txt">{data.tag}</div>
        </div>
        <div className="lg-bp-body">
          {done
            ? <p className="lg-bp-msg" dangerouslySetInnerHTML={{ __html: data.html }} />
            : <p className="lg-bp-msg">{displayed}<span className="lg-bp-cursor" /></p>
          }
        </div>
        <div className="lg-bp-foot">
          <div className="lg-bp-dots">
            {Array.from({ length: TOTAL }).map((_, i) => (
              <div key={i} className={`lg-bpd ${i + 1 === step ? "on" : ""}`} />
            ))}
          </div>
          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            <button className="lg-bp-skip" onClick={onSkip}>Skip guide</button>
            <button
              className="lg-bp-next"
              onClick={onNext}
              onMouseEnter={e => { (e.currentTarget as HTMLButtonElement).style.transform = "translateY(-1px)"; }}
              onMouseLeave={e => { (e.currentTarget as HTMLButtonElement).style.transform = "none"; }}
            >
              {nextLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════════════
   LOGIN PAGE
══════════════════════════════════════════════════ */
const Login: React.FC = () => {
  const {
    email, password, error, isLoading,
    setError, setEmail, setPassword, login,
  } = useAuthStore();

  const [touched,      setTouched]      = useState({ email: false, password: false });
  const [showPassword, setShowPassword] = useState(false);
  const [guideStep,    setGuideStep]    = useState<number | null>(null);

  const ref1 = useRef<HTMLDivElement>(null);
  const ref2 = useRef<HTMLDivElement>(null);
  const ref3 = useRef<HTMLDivElement>(null);
  const ref4 = useRef<HTMLDivElement>(null);
  const refs  = [ref1, ref2, ref3, ref4];

  const signIn       = useSignIn();
  const navigate     = useNavigate();
  const location     = useLocation();
  const redirectPath = new URLSearchParams(location.search).get("redirect") || "/dashboard";

  useEffect(() => {
    injectKF();
    setError("");
    const seen = localStorage.getItem("loginGuide");
    if (!seen) {
      setTimeout(() => setGuideStep(1), 900);
      localStorage.setItem("loginGuide", "true");
    }
  }, []);

  useEffect(() => {
    if (guideStep === null) return;
    refs[guideStep - 1]?.current?.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [guideStep]);

  const handleNext = useCallback(() => setGuideStep(p => (p !== null && p < TOTAL) ? p + 1 : null), []);
  const handleSkip = useCallback(() => setGuideStep(null), []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const res = await login();
      if (res?.data?.token) {
        if (signIn({ auth: { token: res.data.token, type: "Bearer" }, refresh: res.data.refreshToken, userState: res.data.authUserState }))
          navigate(redirectPath);
      }
    } catch (err) { console.error(err); }
  };

  return (
    <>
      {/* ══ NO overlay, NO blur, NO dim — bot floats freely ══ */}

      {/* Bot popup — no overlay behind it */}
      {guideStep !== null && guideStep >= 1 && guideStep <= TOTAL && (
        <BotPopup
          anchorRef={refs[guideStep - 1]}
          step={guideStep}
          data={STEPS[guideStep - 1]}
          onSkip={handleSkip}
          onNext={guideStep < TOTAL ? handleNext : handleSkip}
          nextLabel={guideStep < TOTAL ? "Next →" : "Done ✓"}
        />
      )}

      {/* ════════════ NAVBAR ════════════ */}
      <nav className="mainHeader loginheader navbar navbar-expand-lg navbar-light border-bottom">
        <div className="container">
          <Link to="/" className="navbar-brand">
            <img src={logo} alt="Logo" className="img-fluid header-nav-logo" />
          </Link>
          <div ref={ref1} className="ms-auto">
            <Link to="/signup">
              <button className="btn btn-outline-primary">Create an Account</button>
            </Link>
          </div>
        </div>
      </nav>

      {/* ════════════ PAGE BODY ════════════ */}
      <section className="auth_hero_wrapper position-relative bg-light pt-4">
        <div className="container">
          <div className="row align-items-center">

            <div className="col-lg-6 pe-0 d-none d-lg-block">
              <div className="auth_hero_inner_img" style={{ backgroundImage: `url(${login_bg})` }} />
            </div>

            <div className="col-lg-5 col-md-8 col-sm-10 col-12 ps-lg-0 offset-lg-1 mx-auto mx-lg-0">
              <div className="auth_caption py-4 py-lg-0">
                <h2 className="mb-4">Welcome Back</h2>

                <form onSubmit={handleSubmit} className="auth_form" noValidate>

                  {/* Step 2: Email */}
                  <div ref={ref2} className="mb-3">
                    <label className="form-label fw-semibold text-muted small mb-1">Email Address</label>
                    <input
                      type="email"
                      className={`form-control${touched.email && !email ? " is-invalid" : ""}`}
                      placeholder="you@example.com"
                      value={email}
                      onChange={e => setEmail(e.target.value)}
                      onBlur={() => setTouched(t => ({ ...t, email: true }))}
                      autoComplete="email"
                    />
                    {touched.email && !email && <div className="invalid-feedback">Please enter your email.</div>}
                  </div>

                  {/* Step 3: Password */}
                  <div ref={ref3} className="mb-3">
                    <label className="form-label fw-semibold text-muted small mb-1">Password</label>
                    <div style={{ position: "relative" }}>
                      <input
                        type={showPassword ? "text" : "password"}
                        className={`form-control${touched.password && !password ? " is-invalid" : ""}`}
                        placeholder="Your password"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        onBlur={() => setTouched(t => ({ ...t, password: true }))}
                        autoComplete="current-password"
                        style={{ paddingRight: "44px" }}
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword(p => !p)}
                        style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", fontSize: "16px", color: "#888", lineHeight: 1 }}
                        aria-label={showPassword ? "Hide password" : "Show password"}
                      >
                        {showPassword ? "🙈" : "👁️"}
                      </button>
                    </div>
                    {touched.password && !password && <div className="invalid-feedback d-block">Please enter your password.</div>}
                  </div>

                  <div className="d-flex justify-content-end mb-3">
                    <Link to="/forgot-password" style={{ fontSize: "13px", color: "#ce202e", textDecoration: "none" }}>
                      Forgot password?
                    </Link>
                  </div>

                  {/* Step 4: Sign In */}
                  <div ref={ref4}>
                    <button
                      type="submit"
                      className="btn btn-primary w-100"
                      disabled={isLoading}
                      style={{ fontWeight: 700, letterSpacing: "0.03em" }}
                    >
                      {isLoading
                        ? <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />Signing in…</>
                        : "Sign In"
                      }
                    </button>
                  </div>

                  {error && <div className="alert alert-danger mt-3 py-2 small" role="alert">{error}</div>}

                  <p className="text-center text-muted mt-4 mb-0 small">
                    Don't have an account?{" "}
                    <Link to="/signup" style={{ color: "#ce202e", fontWeight: 600 }}>Create one free</Link>
                  </p>

                </form>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default Login;